import {
  getBenLanguageBackendCode,
  type BenLanguageBackendCode,
} from '@ben/common/languages';
import InputLabelWithHint from '@ben/orion/input-label/input-label-with-hint';
import LanguageSelect from '@ben/orion/language-select';
import type { ReactNode } from 'react';
import { useId } from 'react';

interface ContentProps {
  inputLabel: string;
  hintText?: string;
  children: (language: BenLanguageBackendCode) => ReactNode;
}

const TranslatableField = ({
  inputLabel,
  hintText,
  children,
}: ContentProps) => {
  const inputId = useId();

  return (
    <div>
      <LanguageSelect
        leftSlot={
          <InputLabelWithHint
            name={inputLabel}
            hintText={hintText}
            showLabel
            inputId={inputId}
          />
        }
        panelContent={({ languageCode }) =>
          children(getBenLanguageBackendCode(languageCode))
        }
        isCompact
      />
    </div>
  );
};

export default TranslatableField;
